.rdp-selected {
  font-weight: inherit;
  font-size: inherit;
}

.rdp-today {
  font-weight: 600;
  font-size: inherit;
}